import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import './PageFooter.less';
import { COUNTRY } from '../../../App/AppConstants';
import DEFooter from '../../../../DE/components/Footer/Footer';
import GBFooter from '../../../../GB/components/Footer/Footer';
import USFooter from '../../../../US/components/Footer/Footer';

export class PageFooter extends Component {
    static propTypes = {
        country: PropTypes.oneOf(Object.values(COUNTRY)),

        // Passed in props
        customFooter: PropTypes.node
    };

    render() {
        const { country, customFooter } = this.props;
        let countryFooter;

        switch (country) {
            case COUNTRY.GERMANY:
                countryFooter = <DEFooter />;
                break;
            case COUNTRY.GREAT_BRITAIN:
                countryFooter = <GBFooter />;
                break;
            case COUNTRY.UNITED_STATES:
                countryFooter = <USFooter />;
                break;
        }

        return (
            <footer className="PageFooter">
                {customFooter || countryFooter}
            </footer>
        );
    }
}

const mapStateToProps = state => ({
    country: _.get(state, 'serverData.country')
});

export default connect(mapStateToProps)(PageFooter);
